 // Ajout Simon a revoir si on garde ou pas

/*
 * Animation for the sub menus
 * @param {HTMLelement} arrowIcon
 */
raymont.contactForm = function(valueSelected){
    //console.log(valueSelected);

    // $.ajax({
    //     url : 'yourwebsite/wp-admin/admin-ajax.php',
    //     type : 'post',
    //     data : {
    //         action : 'unread_messages'
    //     },
    //     success : function( response ) {

    //     }
    // });
}